import React, { useState, useEffect } from "react";
import { SearchNangCao } from "./SearchNangCao";
import { useSelector, useDispatch } from "react-redux";
import {
  getListHopDongDelete,
  updateDataSearch,
} from "../../../../actions/DanhSachHopDongDelete";
import { formatDayMonth } from "utils/formatDate";
import { currentDate } from "utils/formatDate";
import { convertDate } from "utils/formatDate";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";

export const SearchBarDesktop = ({}) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const dispatch = useDispatch();

  const dataSearch = useSelector((state) => state.dataSearchHopDongDelete); //dataSearchTaiSan dinh nghia o rootreducer

  const updateState = (field, text) => {
    dispatch(
      updateDataSearch({
        ...dataSearch,
        [field]: text,
        pageIndex: 1,
      })
    );
  };

  const updateTextValue = (field) => (e) => {
    updateState(field, e.target.value);
  };

  const updateDropdown = (field) => (e) => {
    //alert("tuty");
    // console.log(e.target.value);
    updateState(field, e.target.value);
  };

  const onChangeDate = (field) => (evt) => {
    updateState(field, formatDayMonth(evt));
  };

  const onSearch = () => {
    dispatch(getListHopDongDelete(dataSearch));
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      dispatch(
        updateDataSearch({
          ...dataSearch,
          pageIndex: 1,
        })
      );
      dispatch(getListHopDongDelete(dataSearch));
    }
  }; //sự kiện tìm kiếm enter

  // convert sự kiện tìm kiếm từ ngày đến ngày
  var dateFrom = currentDate();
  if (dataSearch.dateFrom === "01/01/2001") dateFrom = "";
  else dateFrom = dataSearch.dateFrom;
  var dateTo = currentDate();
  if (dataSearch.dateTo === "01/01/4000") dateTo = "";
  else dateTo = dataSearch.dateTo;
  dateTo = convertDate(dateTo);
  dateFrom = convertDate(dateFrom);
  return (
    <>
      <div className="search-new hidden-mobile-main show-table-main">
        <div className="input-sm-new input-new-18">
          <label className="font-color-default font-bold">Tên khách hàng</label>
          <input
            className="form-control input-sm"
            placeholder="Tên khách hàng"
            value={dataSearch.NameCus}
            onChange={updateTextValue("NameCus")}
            onKeyDown={handleKeyDown}
          />
        </div>
        <div className="input-sm-new input-new-18">
          <label className="font-color-default font-bold">Số điện thoại</label>
          <input
            className="form-control input-sm"
            value={dataSearch.SDT}
            onChange={updateTextValue("SDT")}
            onKeyDown={handleKeyDown}
            placeholder="Số điện thoại"
          />
        </div>

        <div className="input-sm-new input-new-18">
          <label className="font-color-default font-bold">Số tiền vay</label>
          <input
            className="form-control input-sm"
            value={dataSearch.SoTienVay}
            onChange={updateTextValue("SoTienVay")}
            onKeyDown={handleKeyDown}
            placeholder="Số tiền vay"
          />
        </div>
        <div className="input-sm-new input-new-18">
          <label className="font-color-default font-bold">Người xóa</label>
          <input
            className="form-control input-sm"
            value={dataSearch.NguoiXoa || ""}
            onChange={updateTextValue("NguoiXoa")}
            onKeyDown={handleKeyDown}
            placeholder="Người xóa"
          />
        </div>

        <div className="input-sm-new input-new-18">
          <label className="font-color-default font-bold">Từ ngày</label>
          <DateTimePicker
            value={dateFrom}
            onChange={onChangeDate("dateFrom")}
            placeholder="Từ ngày"
            name="dateFrom"
          ></DateTimePicker>
        </div>

        <div className="input-sm-new input-new-18">
          <label className="font-color-default font-bold">Đến ngày</label>
          <DateTimePicker
            value={dateTo}
            onChange={onChangeDate("dateTo")}
            placeholder="Đến ngày"
            name="dateFrom"
          ></DateTimePicker>
        </div>

        <div className="input-sm-new input-new-14 search-main-new">
          <button
            type="submit"
            className="btn btn-info-new"
            style={{ marginTop: "28px", paddingTop: "7px" }}
            onClick={onSearch}
          >
            <i className="la la-search"></i>
            <span> &nbsp; Tìm kiếm</span>
          </button>
        </div>
        <div
          className="input-sm-new"
          style={{ paddingTop: "25px", width: "8%" }}
        >
          <a href={() => false} onClick={handleShow}>
            <i>
              <PopoversBootrap
                contentText="Tìm kiếm nâng cao"
                trigger={["hover", "focus"]}
                placement={"top"}
              >
                <img
                  className="icon-bred-home"
                  src="/app-assets/images/icon-fitter-v2.png"
                  alt=""
                  style={{ scale: "0.9", verticalAlign: "sub" }}
                />
                {/* <i className="mdi mdi-download"></i> */}
              </PopoversBootrap>
            </i>
          </a>
        </div>

        <SearchNangCao show={show} onHide={handleClose} />
      </div>
    </>
  );
};
